import type { CSSProperties, ReactNode } from 'react';

/**
 * The workspace's bordered surface. `accent` switches to the purple-tinted
 * variant used for "recommended"/lever cards. Padding is left to the caller via
 * `style` because the design uses several different paddings per context.
 */
export function Panel({
  children,
  style,
  accent = false,
  className,
}: {
  children: ReactNode;
  style?: CSSProperties;
  accent?: boolean;
  className?: string;
}) {
  return (
    <div
      className={className}
      style={{
        border: `1px solid ${accent ? 'rgba(181,155,255,0.3)' : 'rgba(255,255,255,0.09)'}`,
        background: accent ? '#16141b' : '#141416',
        borderRadius: 16,
        ...style,
      }}
    >
      {children}
    </div>
  );
}
